import { tgfFunctions } from "../../framework/tgfFunctions";
import { BirdObjectDefault } from "./BirdObject";
export function BirdObjectBig(def, uid, x, y, angle, container) {
    BirdObjectBig.uber.constructor.call(this, def, uid, x, y, angle, container);
}
tgfFunctions.inherit(BirdObjectBig, BirdObjectDefault);
